"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Interactor = void 0;
class Interactor {
    /**
     * Method willActivate is deprecated. You should use onActivate
     * @deprecated
     */
    willActivate() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    onActivate() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    /**
     * Method didActivate is deprecated. You should use afterActivate
     * @deprecated
     */
    didActivate() { }
    afterActivate() { }
    /**
     * Method willDeactivate is deprecated. You should use onDeactivate
     * @deprecated
     */
    willDeactivate() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    onDeactivate() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    /**
     * Method didDeactivate is deprecated. You should use afterDeactivate
     * @deprecated
     */
    didDeactivate() { }
    afterDeactivate() { }
    activate() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.onActivate();
            yield this.willActivate();
            setTimeout(() => {
                this.didActivate();
                this.afterActivate();
            }, 0);
        });
    }
    deactivate() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.willDeactivate();
            yield this.onDeactivate();
            setTimeout(() => {
                this.didDeactivate();
                this.afterDeactivate();
            }, 0);
        });
    }
}
exports.Interactor = Interactor;
//# sourceMappingURL=Interactor.js.map